// extracted by mini-css-extract-plugin
module.exports = {"uploadWrap":"antd-pro-components-uploader-dragger-uploadWrap"};